import { useMemo } from "react";
import type { AnalysisDimension, AnalysisObject } from "@repo/shared";
import { ItemsAnalysisTable } from "./ItemsAnalysisTable";

interface DimensionsAnalysisTableProps {
  analysisId: string;
  dimensions: AnalysisDimension[];
  objects: AnalysisObject[];
}

export function DimensionsAnalysisTable({
  analysisId,
  dimensions,
  objects,
}: DimensionsAnalysisTableProps) {
  const rows = useMemo(
    () =>
      dimensions.map((d) => ({
        id: d.id,
        name: d.title,
        definition: d.fieldDefs.join(", "),
        usage: d.usedInCount,
        used: d.usedInCount > 0,
        broken: d.isBroken,
        indirect: d.isIndirectUsage,
        orphan: d.isOrphanUsageOnly,
        usedIn: d.usedIn,
        issues: d.expressionIssues,
      })),
    [dimensions],
  );
  return (
    <ItemsAnalysisTable analysisId={analysisId} scope="dimensions" rows={rows} objects={objects} />
  );
}
